import './FTBR.css'

function FTBR() {
    return (
      <>
      </>
    );
  }
  
  export default FTBR;